// extracted by mini-css-extract-plugin
module.exports = {"PageTitleContainer":"PageHeading_PageTitleContainer__ATAKI"};